// import {runWaterfall} from '../libs/preroll/main.esm.js';
import { eventBus, EVENTS } from './EventBus.js';
const runWaterfall = window['video-ad-sdk'].runWaterfall;
const requestAd = window['video-ad-sdk'].requestAd;
const CATEGORY_PREROLL_FREQUENCY = 1;
let adUnit;
let done = [];
let evento;
let ip;
let categoryCounter={};
let prevImg='';
let prevHref='';
let imageElement = null;
let aElement = null;

eventBus.on(EVENTS.PLAYER_PODCAST_NEW_SONG, (event) => {
  if (event.type == "podcast") {
    evento = event;
  }
});
function getZone(categorySlug) {
  let slug;
  switch (categorySlug) {
    case 'tutti-pazzi-per-rds':
    case 'tutti-pazzi-per-rds-podcast':
      slug = 'tutti-pazzi-per-rds-preroll'
      break;
    case '100-made-in-italy':
      slug = 'made-in-italy-preroll'
      break;
    case '100-secondi-con-enrico-mentana':
      slug = 'enrico-mentana-preroll'
      break;
    case 'giornale-radio':
      slug = 'giornale-radio-preroll'
      break;
    case 'il-meglio-di-rds':
    case 'podcast-il-meglio-di-rds':
      slug = 'il-meglio-di-rds-preroll'
      break;
    case '100-secondi-con-enrico-mentana':
      slug = 'giornale-radio-preroll'
      break;
    case 'lifestyle':
      slug = 'lifestyle-preroll'
      break;
    case 'meteo':
      slug = 'meteo-preroll'
      break;
    case 'rds-music-for-you-podcast':
      slug = 'music-for-you-preroll'
      break;
    case 'oroscopo-di-branko':
      slug = 'oroscopo-di-branco-preroll'
      break;
    case 'rds-i-grandi-della-musica':
      slug = 'grandi-della-musica-preroll'
      break;
    case 'rds-motori':
      slug = 'rds-motori-preroll'
    case '100-secondi-con-daniele-doesnt-matter':
      slug = '100-secondi-con-daniele-preroll'
    case 'i-peggio-piu-peggio-di-rds':
      slug = 'peggio-di-rds-preroll'
    case 'rds-active':
      slug = 'active_preroll'
      break;
    case '100-secondi-con-radio-serie-a':
      slug = 'active_preroll'
      break;
    case 'rds-green':
      slug = 'Radio_Serie_A_con_RDS_preroll'
    default:
      break;
  }
  return slug;
}

function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  // return true;
}



window.requestAdRun =  (adTag, videoElement, videoAdContainer, player, ignoreEvento, retry) => {
  let arrIdx = 0;
  let errorTriggered = false;
  let _adTag;
  if (Array.isArray(adTag)) {
    if (retry) {
      arrIdx = 1;
    }
    _adTag = adTag;
    adTag = _adTag[arrIdx]
  } else {
    retry = true;
  }
  const isVideo = adTag.endsWith('_video') || adTag == window.urlVideoPreroll;
  const onAdReady = async (newAdUnit) => {
    // debugger;
    // if (player.selector==="#videoplayer"){
    //   player.container.poster ='';
    //   if (window.radioId === 13){
    //     player.container.poster ='https://media.rds.it/web/Tampone_serieA.png';
    //   }
    // }
    player.newAdUnit = newAdUnit;
    if (window.radioId === 13 &&  player.selector === "#diretta-play"){
      //DISPLAY
      const display = await requestAd('https://rds.deliveryengine.adswizz.com/vast/4.0/request/alias/RadioSerieA_Display');
      if (display[0].errorCode == null){
        const srcDisplay = display[0].ad.elements[0].elements[5].elements[0].elements[0].elements[2].elements[0].elements[0].text;
        const hrefDisplay = display[0].ad.elements[0].elements[5].elements[0].elements[0].elements[3].elements[1].elements[0].text;
        imageElement = document.getElementById('mpuPh').children[0].children[0];
        aElement = document.getElementById('mpuPh').children[0];
        prevImg=imageElement.src;
        prevHref = aElement.href;
        imageElement.src = srcDisplay;
        aElement.href = hrefDisplay;
      }
    }

    $('#rds-main .podcast-play').append('<div class="block-preroll-layer remove-after-preroll"></div>');
    $('.block-preroll-layer').show();
    const btnToggleRadios = document.getElementById('btnGuardaSerieAWrapper');
    if(btnToggleRadios){
      btnToggleRadios.classList.add('btn_guarda_seriea-disabled');
    }

    if(isVideo){
      videoAdContainer.classList.add('video-ad-container');
      if(isIOS()){
        player.container.parentElement.classList.add('ios-videopreroll');
        //ios-videopreroll
      }
    }

    player.settingPreroll=false;
    adUnit = newAdUnit;
    console.log('### onAdReady', adUnit);
    adUnit.on('start',()=>{
      player.triggerEvent('IMA_START',{isVideo})
    })
    const evtHandler = (evt) => console.log(`### ${evt.type}`, evt.adUnit);

    [
      'pause',
      'resume',
      'finish',
      'impression',
      'start',
      'skip',
      'firstQuartile',
      'midpoint',
      'thirdQuartile',
      'complete'
    ].forEach((evtType) => {
      adUnit.on(evtType, evtHandler);
    });
  };
  const src = player.getSource();
  function randomString(length) {
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var result = '';
    for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  }


  const user = window.user.getLocalUser();
  let paramsString = '';
  let params = {};
  // params['listenerId'] = '5b95683f142900ff7758a318b17314c1';
  params['listenerId'] = window.com_adswizz_synchro_listenerid || randomString(32);
  params['sessionId'] = randomString(32);
  // params['duration']=41000;
  params['maxAds']=1;
  if(window.gdpr_consent){
    params['aw_0_req.userConsentV2']=window.gdpr_consent;
    try {
      if (user) {
        if (user.genere) {
          params['aw_0_1st.gender'] = user.genere == 'm' ? 'male' : 'female';
        }
        if (user.nascita) {
          const now = new Date();
          const msDiff = now - new Date(user.nascita);
          const ageDate = new Date(msDiff);
          const age = Math.abs(ageDate.getUTCFullYear() - 1970);
          params['aw_0_1st.age'] = age;
        }
      }
    } catch (error) {
      console.warn(error);
    }
  }
  if (evento && !ignoreEvento) {
    console.log(evento);
    const catSlug = evento.slug.replace('/podcast/', '/').split('/')[1];
    const zone = getZone(catSlug);
    if (!categoryCounter[catSlug]) {
      categoryCounter[catSlug] = {counter: 0};
    }
    if (categoryCounter[catSlug] && categoryCounter[catSlug].counter == CATEGORY_PREROLL_FREQUENCY) {
      categoryCounter[catSlug].counter = 0;
    }
    if (categoryCounter[catSlug].counter > 0) {
      categoryCounter[catSlug].counter++;
      player.player.trigger('IMA_END');
      return;
    }
    categoryCounter[catSlug].counter++;
    params['awCollectionId'] = evento.category_slug;
    params['awEpisodeId'] = evento.id;
    params['aw_0_cnt.url'] = evento.audioSrc;
    if (zone) {
      adTag = adTag.replace('radio_dimensione-suono-rds', getZone(catSlug));
    }
    // evento = null;
  }
  if (ignoreEvento) {
    const catSlug = 'diretta';
    if (!categoryCounter[catSlug]) {
      categoryCounter[catSlug] = {counter: 0};
    }
    if (categoryCounter[catSlug] && categoryCounter[catSlug].counter == CATEGORY_PREROLL_FREQUENCY) {
      categoryCounter[catSlug].counter = 0;
    }
    if (categoryCounter[catSlug].counter > 0) {
      categoryCounter[catSlug].counter++;
      player.player.trigger('IMA_END');
      return;
    }
    categoryCounter[catSlug].counter++;
  }
  paramsString += '?' + jQuery.param(params);
  adTag += paramsString;

  const resumeContent = () => {
    videoElement.play();

    videoElement.removeEventListener('contentloadedmetadata', resumeContent);
    videoElement.removeEventListener('canplay', resumeContent);
  };
  const onError = (evt) => {
    if (errorTriggered) {
      return;
    }
    errorTriggered = true;
    player.settingPreroll = false;
    $('.remove-after-preroll').remove();
    $('.block-preroll-layer').hide();
    console.log('### onError', evt);
    videoAdContainer.classList.remove('video-ad-container')
    player.container.parentElement.classList.remove('ios-videopreroll');
    // if(isIOS()){
    //   videoElement.removeEventListener('click', onClickIOS);
    // }
    player.waitPreroll = true;
    player.player.trigger('IMA_END');
    console.log('***error', adTag);
    player.player.load();
    if (_adTag && !retry) {
      player.setSource(src);
      requestAdRun(_adTag, videoElement, videoAdContainer, player, ignoreEvento, true);
    }

  };
  const onRunFinish = (evt) => {
    if (errorTriggered && !retry) {
      return;
    }
    $('.remove-after-preroll').remove();
    $('.block-preroll-layer').hide();
    const btnToggleRadios = document.getElementById('btnGuardaSerieAWrapper');
    if(btnToggleRadios){
      btnToggleRadios.classList.remove('btn_guarda_seriea-disabled');
    }
    console.log('### onRunFinish', evt);
    console.log('***finish', adTag);
    if (imageElement){
      imageElement.src = prevImg;
    }
    if (aElement){
      aElement.href = prevHref;
    }
    videoAdContainer.classList.remove('video-ad-container')
    player.container.parentElement.classList.remove('ios-videopreroll')
    // if(isIOS()){
    //   videoElement.removeEventListener('touchstart', onClickIOS);
    // }
    player.player.trigger('IMA_END');
    videoAdContainer.classList.remove('active');

    if (videoElement.src === src) {
      videoElement.play();
    } else {
      videoElement.addEventListener('contentloadedmetadata', resumeContent);
      videoElement.addEventListener('canplay', resumeContent);
      videoElement.load();
      player.setSource(src);
      player.waitPreroll = true;
      player.play();
    }
  };
  window.isPrerollRunning = false;
  videoAdContainer.classList.add('active');
  videoElement.pause();
  videoElement.currentTime = 0;

  console.log('### adTag', adTag);
  player.settingPreroll = true;
  const adOptions = {
    onAdReady,
    onError,
    onRunFinish,
    timeout: 15000,
  }
  if (isIOS()) {
    adOptions.videoElement = videoElement;
    // videoElement.addEventListener('touchst art', onClickIOS);
    // videoAdContainer=player.container.parentElement;
  }
  runWaterfall(adTag, videoAdContainer, adOptions);
};
